export default class CreatePurchaseOrderLine {
    orderNo:number;
    sku:string;
    productName:string;
    productId :number;
    orderQty:number;
    isPrep:boolean;
    packedQty:number=0;
    id:number;
    batchCode:string;
    manufactureMonth:Date;
    month: number;
    year:number;
    price :number;
    tax:number;
    note:string;
}